import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.96 5.54a6.75 6.75 0 00-1.961-.29c-2.207 0-3.652.809-4.806 2.106-.967 1.087-1.338 2.438-1.338 3.449 0 2.902 2.813 5.013 5.953 4.945h.022c.602 0 1.183-.2 1.599-.502.424-.309.593-.651.593-.92 0-.541-.208-.842-.557-1.084-.407-.283-.987-.468-1.71-.672a95.31 95.31 0 00-.172-.048c-.626-.175-1.36-.38-1.937-.72a2.616 2.616 0 01-.885-.813 2.294 2.294 0 01-.364-1.28c0-1.774 1.64-2.961 3.433-2.961 1.766 0 3.186 1.04 3.466 2.268a.75.75 0 01-1.463.333c-.083-.367-.736-1.101-2.003-1.101-1.24 0-1.933.767-1.933 1.461a.8.8 0 00.12.46c.072.11.193.225.389.34.4.236.948.39 1.637.584l.12.034c.684.193 1.51.433 2.158.883.706.49 1.201 1.23 1.201 2.315 0 .906-.544 1.65-1.212 2.134a4.282 4.282 0 01-2.478.789c-3.676.075-7.477-2.43-7.477-6.445 0-1.331.476-3.05 1.717-4.446C7.49 4.766 9.332 3.75 11.998 3.75m0 0a8.25 8.25 0 11-2.133 16.219.75.75 0 01.388-1.449 6.75 6.75 0 003.706-12.98",
      "clip-rule": "evenodd"
    })
  ]))
}